module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/deluxe_tablet-da435871cc35397339ff99c622d8762b.jpg";